import notificationError from '@/utils/functions/notificationError';
import { Modal, Table } from 'antd';
import { AxiosError } from 'axios';

function invoiceHandleError(error: unknown, title?: string) {
  const err = error as AxiosError;

  const hasDuplicateError = err.response?.data?.message.includes(
    'Rejeicao: Duplicidade de',
  );

  if (!hasDuplicateError && !!err.response?.data?.message) {
    const dataErrors = err.response?.data.message
      .split('\n')
      .map((error: string) => error.replace('- ', '').trim())
      .filter(
        (error: string) => error && !error.startsWith('Erro na validação'),
      )
      .map((error: string) => ({ message: error }));

    Modal.confirm({
      width: '80%',
      title: title ?? 'Campos necessários para a transmissão da nota.',
      content: (
        <Table
          className="table-small"
          dataSource={dataErrors}
          columns={[
            {
              title: 'Mensagem',
              dataIndex: 'message',
              key: 'message',
            },
          ]}
          pagination={false}
          scroll={{ x: true }}
        />
      ),
      okText: 'Fechar',
      cancelButtonProps: { hidden: true },
    });
  } else if (hasDuplicateError && !!err.response?.data?.message) {
    return err.response?.data;
  } else {
    notificationError(error);
  }
}

export default invoiceHandleError;
